<template>
  <ElDropdown
    trigger="click"
    placement="bottom-end"
    @command="$emit('select')"
  >
    <AppButton
      type="primary"
      text
      circle
      aria-label="Menü"
      aria-haspopup="true"
    >
      <FaIcon name="ellipsis" />
    </AppButton>

    <template #dropdown>
      <ElDropdownMenu class="el-dropdown-menu--plain py-2">
        <ElDropdownItem
          v-for="item in items"
          :key="item"
          :command="item"
        >
          <div class="flex flex-row items-center text-sm sm:text-base text-gray-700 gap-2.5 whitespace-nowrap hover:bg-gray-100 cursor-pointer px-4 py-1.5">
            <FaIcon
              name="envelope-open"
              variant="light"
            />
            {{ item }}
          </div>
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>
<script setup lang="ts">
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from 'element-plus';
import AppButton from '@/application/components/ui/AppButton.vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';

interface Props {
  items: string[];
}

defineProps<Props>();

defineEmits(['select'])
</script>
